import { useState, useEffect } from 'react';
import { Info, Megaphone, AlertTriangle, X } from 'lucide-react';

const API_URL = process.env.NODE_ENV === 'production' ? '' : (process.env.REACT_APP_BACKEND_URL || '');

const ICONS = { info: Info, update: Megaphone, warning: AlertTriangle };
const STYLES = {
  info: 'bg-blue-50 border-blue-200 text-blue-800',
  update: 'bg-emerald-50 border-emerald-200 text-emerald-800',
  warning: 'bg-amber-50 border-amber-200 text-amber-800',
};

export default function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState([]);
  const [dismissed, setDismissed] = useState(() => {
    try { return JSON.parse(localStorage.getItem('dismissed_announcements') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    fetch(`${API_URL}/api/public/announcements`)
      .then(r => r.json())
      .then(data => setAnnouncements(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const dismiss = (id) => {
    const next = [...dismissed, id];
    setDismissed(next);
    localStorage.setItem('dismissed_announcements', JSON.stringify(next));
  };

  const visible = announcements.filter(a => !dismissed.includes(a.id));
  if (visible.length === 0) return null;

  return (
    <div className="space-y-2 mb-6" data-testid="announcement-banners">
      {visible.map(a => {
        const Icon = ICONS[a.type] || Info;
        const style = STYLES[a.type] || STYLES.info;
        const daysLeft = Math.max(0, Math.ceil((new Date(a.expires_at) - new Date()) / 86400000));
        return (
          <div key={a.id} className={`flex items-start gap-3 px-4 py-3 rounded-lg border ${style}`} data-testid={`announcement-${a.id}`}>
            <Icon className="h-5 w-5 flex-shrink-0 mt-0.5" />
            <div className="flex-1 min-w-0">
              {a.title && <p className="font-semibold text-sm">{a.title}</p>}
              <p className="text-sm leading-relaxed">{a.message}</p>
              <p className="text-[10px] mt-1 opacity-60">
                {new Date(a.created_at).toLocaleDateString('de-DE')} · noch {daysLeft} Tag{daysLeft !== 1 ? 'e' : ''} sichtbar
              </p>
            </div>
            <button onClick={() => dismiss(a.id)} className="flex-shrink-0 opacity-40 hover:opacity-100 transition-opacity" data-testid={`dismiss-announcement-${a.id}`}>
              <X className="h-4 w-4" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
